import { setLogLevel } from '@ms/yammer-console-logging';
import { getBrowserInfo, reportInfo, reportUsage } from '@ms/yammer-telemetry';
import { getUrlRootPath } from '@ms/yammer-web-support/dist/location';
import config from 'bootstrap/config';
import { getAppLaunchInitiator, isBackgroundLoad } from 'state/teamsContext/selectors';

type ReportBootstrapStarted = () => Promise<void>;
export const reportBootstrapStarted: ReportBootstrapStarted = async () => {
  reportInfo({
    eventName: 'bootstrap_started',
    eventProperties: {
      ...getBrowserInfo(),
      urlRootPath: getUrlRootPath(window.location.pathname),
    },
  });
};

type ReportBootstrapCompleted = () => void;
export const reportBootstrapCompleted: ReportBootstrapCompleted = () => {
  if (isBackgroundLoad()) {
    return;
  }

  const initiator = getAppLaunchInitiator();
  reportUsage({
    eventName: 'bootstrap_completed',
    eventProperties: {
      initiator,
    },
  });
};

export const setupLogging: VoidFunction = () => {
  setLogLevel(config.logging.logLevel);
};
